var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9504 38.0037H51.2827C36.7791 38.0037 24.9682 26.4712 24.9682 12.3094V0H38.8598V12.3691C38.8598 19.0616 44.4287 24.4395 51.2215 24.4395H63.8892V38.0037H63.9504Z",
    fill: "#062021"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4328 62.4431H28.5176V41.4694L21.48 34.5976H0V27.7856H24.3562L35.4328 38.6609V62.4431Z",
    fill: "#062021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9c0f59e38127ee0283f42aca260d803b.svg";
export { ForwardRef as ReactComponent };